import Grid from '@/global/components/ui/Grid'
import Menu from '@/global/components/MenuV2'
import { CategoriaEnum, Categorias } from '@acme/auth'
import { FormField } from 'global/components/Form'
import { useFormContext } from 'react-hook-form'

const CATEGORIAS_COM_CLIENTE = [
    CategoriaEnum.Cliente,
    CategoriaEnum.Avaliacao,
    CategoriaEnum.Supervisor,
    CategoriaEnum.Funcionario,
]

const OPCOES = Object.entries(Categorias)
    .filter(([id]) => Number(id) !== CategoriaEnum.Publico)
    .map(([id, label]) => ({ value: Number(id), label }))

export function EditarUsuarioFormFields() {
    const { watch } = useFormContext()
    const categoriaId = watch('categoriaId')

    return (
        <Grid container rowSpacing={2} columnSpacing={3}>
            <Grid item xs={12}>
                <FormField
                    disabled
                    select
                    name="categoriaId"
                    label="Categoria de acesso"
                >
                    {OPCOES.map(({ value, label }) => (
                        <Menu.Item key={value} value={value}>
                            {label}
                        </Menu.Item>
                    ))}
                </FormField>
            </Grid>
            <Grid item xs={12}>
                <FormField name="email" label="Email" required type="email" />
            </Grid>
            {CATEGORIAS_COM_CLIENTE.includes(categoriaId) && (
                <Grid item xs={12}>
                    <FormField
                        name="clienteId"
                        label="ID do Cliente"
                        type="number"
                    />
                </Grid>
            )}
            <Grid item xs={12} sm={6}>
                <FormField
                    name="password"
                    label="Nova senha (opcional)"
                    hiddenPassword
                    autoComplete="off"
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormField
                    name="confirme"
                    label="Confirme a nova senha"
                    hiddenPassword
                    autoComplete="off"
                />
            </Grid>
        </Grid>
    )
}
